var map = {
	"./angpao.webp": 2329,
	"./bonus.webp": 2330,
	"./gpi-rebate-m.webp": 2331,
	"./gpi-rebate.webp": 2332,
	"./hublot-watch-2018.webp": 2333,
	"./hublot-watch-2022.webp": 2334,
	"./iphone-13-pro-max.webp": 2335,
	"./iphone-14-pro-max.webp": 2336,
	"./login-to-m.webp": 2337,
	"./login-to.webp": 2338,
	"./mb.webp": 2339,
	"./mg-rebate-m.webp": 2340,
	"./mg-rebate.webp": 2341,
	"./np.webp": 2342,
	"./pointer.webp": 2343,
	"./pp-rebate-m.webp": 2344,
	"./pp-rebate.webp": 2345,
	"./sadface.webp": 2346,
	"./wallet-m.webp": 2347,
	"./wallet.webp": 2348,
	"./wheel-b.webp": 2349,
	"./wheel-btn.webp": 2350,
	"./wheel-indon-b.webp": 2351,
	"./wheel-indon.webp": 2352,
	"./wheel.webp": 2353
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 935;